export const Profession_DATA = [
  "Doctor",
  // "Paramedics",
  "Mankind Employee",
  "Student",
  "Consumer",
];
export const hideSpecialityForProfession = ["Consumer"];
export const showEmployeeCodeForProfession = ["Mankind Employee",];
